var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"navigation-wrap"},[_c('nav-top',{staticClass:"nav-top"}),_vm._v(" "),(_vm.isMenuVisible)?_c('nav-menu-mobility'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"booking-header"},[(_vm.isMenuVisible)?_c('nav-booking-mobility'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }